module.exports = __webpack_public_path__ + "img/money-euro-circle-fill.278abc42.svg";